function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.8066 16H1.68164V13.375C1.68164 12.4081 2.46477 11.625 3.43164 11.625H20.0566C21.0235 11.625 21.8066 12.4081 21.8066 13.375V16V16Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.68164 17.75H21.8066V16H1.68164V17.75Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.68164 17.75V19.5",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8066 17.75V19.5",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.3066 5.5H5.18164C4.21477 5.5 3.43164 6.28312 3.43164 7.25V11.625H20.0566V7.25C20.0566 6.28312 19.2735 5.5 18.3066 5.5V5.5Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.89183 8.78786L5.45433 10.5379C5.31608 11.09 5.73433 11.6255 6.30308 11.6255H9.5572C10.0411 11.6255 10.4322 11.2335 10.4322 10.7505V9.00049C10.4322 8.51661 10.0411 8.12549 9.5572 8.12549H6.74058C6.33895 8.12549 5.98895 8.39849 5.89183 8.78786V8.78786Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.597 8.78786L18.0345 10.5379C18.1728 11.09 17.7545 11.6255 17.1858 11.6255H13.9316C13.4478 11.6255 13.0566 11.2335 13.0566 10.7505V9.00049C13.0566 8.51661 13.4478 8.12549 13.9316 8.12549H16.7483C17.1499 8.12549 17.4999 8.39849 17.597 8.78786V8.78786Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcoAccomdation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAccomdation);
export default __webpack_public_path__ + "static/media/ico-accomdation.36ab263d.svg";
export { ForwardRef as ReactComponent };